import type { StoreApi } from 'zustand';
import { create } from 'zustand';
import { tsrClient } from '@/libs/ts-rest/ts-client';

export type AuthStore = {
	status: 'authenticated' | 'unauthenticated' | 'loading';
	user:                null | {
		email:       string;
		name:        string;
		phoneNumber: string;
		dateOfBirth: string | null;
	};
	clear:               () => void;
	setAuthStore:		      StoreApi<AuthStore>['setState'];
	checkIsAuthenticate: () => boolean;
	isPending:           () => boolean;
	fetchSession:        () => Promise<void>;
};

export const useAuthStore = create<AuthStore>((set, get) => ({
	user:   null,
	status: 'loading',
	clear:  () => set({
		user:   null,
		status: 'unauthenticated',
	}),
	setAuthStore:	(newData) => {
		set(newData);
	},
	checkIsAuthenticate: () => get().status === 'authenticated',
	isPending:           () => get().status === 'loading',
	fetchSession:        async() => {
		try {
			const response = await tsrClient.web.auth.getSession.query();

			if (response.status === 200) {
				set({
					user:   response.body.data.session,
					status: 'authenticated',
				});
			}
			else {
				set({
					user:   null,
					status: 'unauthenticated',
				});
			}
		}
		catch (error) {
			console.error(error);
			set({
				user:   null,
				status: 'unauthenticated',
			});
		}
	},
}));

useAuthStore.getState().fetchSession();